import React from "react"
import { useState, useCallback, useContext } from "react"
import DodoneContext from 'app/dodones/Context'
import ConfirmableSpinnableButton from 'app/components/buttons/ConfirmableSpinnable'

export default ({ text = "Bora" }) => {
  const { startDodone, updateDodone } = useContext(DodoneContext)

  return <div className="input-group">
           <ConfirmableSpinnableButton className="btn btn-primary btn-block" onConfirm={ startDodone } isSpinning={ updateDodone.isPending }>
             { text }
           </ConfirmableSpinnableButton>
         </div>
}
